import Model from "../Model";

export interface TReportingPeriod {
  id: number;
  reportingTypeCode: string;
  name: string;
  valid: boolean;
  numberOfReportingPeriod: number;
  status: string;
  periodFrom?: Date;
  periodTo?: Date;
  tag?: string;
  inputAvailableFrom?: Date;
  inputAvailableTo?: Date;
  reportingPeriodId: number;
  reportingTypeName?: string;
  reportingTypeDescription?: string;
}

export interface IReportingPeriod extends TReportingPeriod {}

const ReportingPeriod = Model(
  (model: TReportingPeriod): IReportingPeriod => {
    const _reportingPeriod: TReportingPeriod = Object.assign({}, model);

    return {
      get id() {
        return _reportingPeriod.id;
      },

      get reportingTypeCode() {
        return _reportingPeriod.reportingTypeCode;
      },

      set reportingTypeCode(value: any) {
        _reportingPeriod.reportingTypeCode = value;
      },

      get name() {
        return _reportingPeriod.name;
      },

      set name(value: any) {
        _reportingPeriod.name = value;
      },

      get valid() {
        return _reportingPeriod.valid;
      },

      set valid(value: any) {
        _reportingPeriod.valid = value;
      },

      get numberOfReportingPeriod() {
        return _reportingPeriod.numberOfReportingPeriod;
      },

      set numberOfReportingPeriod(value: any) {
        _reportingPeriod.numberOfReportingPeriod = value;
      },

      get status() {
        return _reportingPeriod.status;
      },

      set status(value: any) {
        _reportingPeriod.status = value;
      },

      get periodFrom() {
        return _reportingPeriod.periodFrom;
      },

      set periodFrom(value: any) {
        _reportingPeriod.periodFrom = value;
      },

      get periodTo() {
        return _reportingPeriod.periodTo;
      },

      set periodTo(value: any) {
        _reportingPeriod.periodTo = value;
      },

      get tag() {
        return _reportingPeriod.tag;
      },
      set tag(value) {
        _reportingPeriod.tag = value;
      },

      get inputAvailableFrom() {
        return _reportingPeriod.inputAvailableFrom;
      },
      set inputAvailableFrom(value: any) {
        _reportingPeriod.inputAvailableFrom = value;
      },

      get inputAvailableTo() {
        return _reportingPeriod.inputAvailableTo;
      },

      set inputAvailableTo(value: any) {
        _reportingPeriod.inputAvailableTo = value;
      },

      get reportingPeriodId() {
        return _reportingPeriod.reportingPeriodId;
      },

      set reportingPeriodId(value) {
        _reportingPeriod.reportingPeriodId = value;
      },

      get reportingTypeName() {
        return _reportingPeriod.reportingTypeName;
      },

      set reportingTypeName(value) {
        _reportingPeriod.reportingTypeName = value;
      },

      get reportingTypeDescription() {
        return _reportingPeriod.reportingTypeDescription;
      },

      set reportingTypeDescription(value) {
        _reportingPeriod.reportingTypeDescription = value;
      }
    };
  }
);

export default ReportingPeriod;
